<template>
    <div class="row">

        <div class="col-12 col-sm-6 col-lg-4">
            <a href="#" class="card-store">
                <div class="store">
                    <figure class="icon-store icon-green">
                        <img src="~@/assets/images/home/featured-stores/icon-dne-token.svg" alt="DNE Token">
                    </figure>

                    <div class="info-store">
                        <h3>DNE Token</h3>
                        <span>Adquira os seus DNE Token</span>
                    </div>
                </div>
            </a>
        </div>

        <div class="col-12 col-sm-6 col-lg-4">
            <a href="#" class="card-store">
                <div class="store">
                    <figure class="icon-store">
                        <img src="~@/assets/images/home/featured-stores/icon-sport-zone.png" alt="Sport Zone">
                    </figure>

                    <div class="info-store">
                        <h3>Sport Zone</h3>
                        <span>Artigos de desporto</span>
                    </div>
                </div>
            </a>
        </div>

        <div class="col-12 col-sm-6 col-lg-4">
            <a href="#" class="card-store">
                <div class="store">
                    <figure class="icon-store icon-blue">
                        <img src="~@/assets/images/home/featured-stores/icon-zenith-saude.svg" alt="Zenith Saúde">
                    </figure>

                    <div class="info-store">
                        <h3>Zenith Saúde</h3>
                        <span>Experimente a medicina estética</span>
                    </div>
                </div>
            </a>
        </div>

        <div class="col-12 col-sm-6 col-lg-4">
            <a href="#" class="card-store">
                <div class="store">
                    <figure class="icon-store icon-green">
                        <img src="~@/assets/images/home/featured-stores/icon-dne-token.svg" alt="DNE Token">
                    </figure>

                    <div class="info-store">
                        <h3>DNE Token</h3>
                        <span>Adquira os seus DNE Token</span>
                    </div>
                </div>
            </a>
        </div>

        <div class="col-12 col-sm-6 col-lg-4">
            <a href="#" class="card-store">
                <div class="store">
                    <figure class="icon-store">
                        <img src="~@/assets/images/home/featured-stores/icon-sport-zone.png" alt="Sport Zone">
                    </figure>

                    <div class="info-store">
                        <h3>Sport Zone</h3>
                        <span>Artigos de desporto</span>
                    </div>
                </div>
            </a>
        </div>

        <div class="col-12 col-sm-6 col-lg-4">
            <a href="#" class="card-store">
                <div class="store">
                    <figure class="icon-store icon-blue">
                        <img src="~@/assets/images/home/featured-stores/icon-zenith-saude.svg" alt="Zenith Saúde">
                    </figure>

                    <div class="info-store">
                        <h3>Zenith Saúde</h3>
                        <span>Experimente a medicina estética</span>
                    </div>
                </div>
            </a>
        </div>

    </div>
</template>


<script>
    import getMyContentLanguage from "@/services/contentLanguage.js"

    export default {
        data(){
            return {
                flagSelected: "en",
            }
        },

        methods: {
            languageSelected(){
                this.flagSelected = this.$store.state.SelectLanguage.code
            },

            getMyLanguage(group, code) {
                return getMyContentLanguage(group, code, this.$store.state.SelectLanguage.code)
            },
        },

        watch: {
            '$store.state.SelectLanguage.code': {
                immediate: true,
                handler() {
                    this.languageSelected();
                }
            }
        }
    }
</script>

<style src="@/assets/scss/_card-store.scss" lang="scss" scoped />